// 订单相关
let Baseurl = process.env.NODE_ENV === 'development' ? '' : 'https://ocenter.xueersi.com'
const Order = {
  getOrderDetail: Baseurl + '/MyOrderData/getOrderDetail',
  ajaxGetOrderList: Baseurl + '/MyOrderData/getOrderList',
  ajaxUserOrderAmount: Baseurl + '/MyOrderData/ajaxUserOrderAmount',
  ajaxGetPackageAdd: 'https://ocenter.xueersi.com/MyInfoData/ajaxGetPackageAdd',
  ajaxStuAdds: 'https://ocenter.xueersi.com/MyInfoData/ajaxStuAdds',
  saveSendInfosAddsById: 'https://ocenter.xueersi.com/MyInfoData/saveSendInfosAddsById',
  saveNewSendInfosAdds: 'https://ocenter.xueersi.com/MyInfoData/saveNewSendInfosAdds',
  getReturnProductInfo: Baseurl + '/Web/RefundInfo/index',
  ajaxCancelOrder: 'https://ocenter.xueersi.com/MyOrderData/ajaxCancelOrder',
  cancelReturnProduct: 'https://ocenter.xueersi.com/MyOrderData/cancelReturnProduct',
  checkReturnProduct: 'https://ocenter.xueersi.com/Web/CheckRefund/index', // 检查是否可以退费
  getDropDetail: 'https://api.xueersi.com/ocenter/Web/RefundedProcess/index' // 获取退费详情
}

export default { Order }



// WEBPACK FOOTER //
// ./module/order/src/service/service.js